var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchSm = function SvgSearchSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.409 14.405q1.774-1.778 1.774-4.317t-1.776-4.319-4.312-1.779q-2.538 0-4.316 1.778Q4 7.545 4 10.086q0 2.538 1.778 4.318 1.777 1.779 4.317 1.779t4.314-1.778m-4.313 3.278q-3.167 0-5.381-2.215T2.5 10.086t2.215-5.381 5.381-2.215 5.377 2.215 2.21 5.381q0 1.38-.452 2.599a7.6 7.6 0 0 1-1.262 2.205l5.531 5.546-1.044 1.064-5.556-5.54a7.413 7.413 0 0 1-4.804 1.723"
  })));
};
export default SvgSearchSm;